import React, {useCallback, useContext} from 'react';
import {FaBold, FaItalic, FaStrikethrough, FaUnderline} from "react-icons/fa";
import {EditorContext, useEditorState} from "@tiptap/react";

const actionIcons = {
    bold: FaBold,
    italic: FaItalic,
    underline: FaUnderline,
    strike: FaStrikethrough
}

const actionsTitle = {
    bold: "Negrito (Ctrl+B)",
    italic: "Itálico (Ctrl+I)",
    underline: "Sublinhar (Ctrl+U)",
    strike: "Tachado (Ctrl+Shift+S)",
}

const RichTextActionButton = ({type}) => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null

    const isActive = useEditorState({
        editor,
        selector: ({ editor }) => !!editor?.isActive(type),
    });

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            if (!editor) return
            editor.chain().focus().toggleMark(type).run()
        },
        [editor, type]
    )

    const Icon = actionIcons[type]

    return (
        <button className={"rich-text-button" + (isActive ? " active" : "")} onClick={handleClick} title={actionsTitle[type]}>
            <Icon className="rich-text-button-icon" />
        </button>
    );
};

export default RichTextActionButton;